import PlatformTracker from './PlatformTracker';
import TrackerFactory from './TrackerFactory';

export default class Tracker {
  private static tracker: PlatformTracker;
  private constructor() {
    // private constructor to prevent instantiation
  }
  public static getInstance(tenantName: string) {
    if (!this.tracker) {
      this.tracker = new TrackerFactory().createTracker(tenantName);
    }
    return this.tracker;
  }
}
